import ImpactDetectionMapReducer from './impactDetectionMapSlice';
import AssetTypeSlice from './assetTypeSlice';

export const ImpactDetectionSliceReducers = {
  impactDetectionMap: ImpactDetectionMapReducer,
  assetTypes: AssetTypeSlice,
};
